import React from "react";

export const Span = ({ children, className,onClick}) => {
  return <span className={className} onClick={onClick}>{children}</span>;
};
